<template>
<div>
  <div class="p-4 m-2" v-show="item.status">
    <div class="p-3">
      <p>ステータス</p>
      <p class="font-weight-bold">{{ statusText }}</p>
    </div>
  </div>
<div class="bg-faded p-4 mb-5 mt-2">
  <div class="p-3">
    <p>イベント番号</p>
    <p class="font-weight-bold">{{ eventNo }}</p>
  </div>
  <div class="p-3">
    <p>カテゴリ</p>
    <p class="font-weight-bold">教室</p>
  </div>
  <div class="p-3">
    <p>教室名・タイトル</p>
    <p class="font-weight-bold">{{ item.event_name }}</p>
  </div>
  <div class="p-3">
    <p>講師名（活動名）</p>
    <p class="font-weight-bold">{{ item.lecturer_name }} 先生</p>
  </div>
  <div class="p-3">
    <p>開催日</p>
    <pre class="font-weight-bold">{{ item.event_date }}</pre>
  </div>
  <div class="p-3">
    <p>開催日(一覧表示用)</p>
    <p v-if="item.event_date_public" class="font-weight-bold">{{ item.event_date_public }}</p>
    <pre v-else class="font-weight-bold">{{ eventDatePublicMulti }}</pre>
    <pre v-if="!item.event_date_public" class="font-weight-bold">開催日の23:59まで掲載されます。</pre>
  </div>
  <div v-if="item.event_date_public" class="p-3">
    <p>掲載終了日</p>
    <p class="font-weight-bold">{{ item.end_date }}</p>
  </div>
  <div class="p-3">
    <p>開催場所・住所</p>
    <p class="font-weight-bold">{{ fullAddress }}</p>
  </div>
  <div class="p-3">
    <p>問い合わせ先電話番号</p>
    <p class="font-weight-bold">{{ tel }}</p>
  </div>
  <div class="p-3">
    <p>問い合わせ先メールアドレス</p>
    <p class="font-weight-bold">{{ email }}</p>
  </div>
  <div class="form-group p-3">
    <p>会場名</p>
    <p class="font-weight-bold">{{ venueName }}</p>
  </div>
  <div class="p-3">
    <p>会場ホームページ（アクセス方法）</p>
    <p class="font-weight-bold">{{ homepage }}</p>
  </div>
  <div class="p-3">
    <p>講師ホームページ・ブログ記事URL</p>
    <p class="font-weight-bold">{{ item.lecturer_url }}</p>
  </div>
  <div class="p-3">
    <p>教室詳細</p>
    <pre class="font-weight-bold">{{ item.description }}</pre>
  </div>
  <div class="p-3">
    <p>参加費</p>
    <pre class="font-weight-bold">{{ item.fee }}</pre>
  </div>
  <div class="p-3">
    <p>お申し込みURL</p>
    <p class="font-weight-bold">{{ item.entry_url }}</p>
  </div>
  <div class="p-3">
    <p>駐車場有無</p>
    <p class="font-weight-bold">{{ item.parking }}</p>
  </div>
  <div class="p-3">
    <p>教室画像</p>
    <div class="row">
      <image-item v-for="f in images.filter(i => i !== '')"
        :key="f"
        :image="f"
        />
    </div>
  </div>
  <div class="p-3">
    <p>公開設定</p>
    <p class="font-weight-bold">{{ item.published }}</p>
  </div>
  <div class="p-3" v-if="visibleApplyDate">
    <p>申請日</p>
    <p class="font-weight-bold">{{ formatedApplyDate }} {{ formatedApplyDatePassed }}</p>
  </div>
</div>
</div>
</template>

<script>
import util from 'util/common'
import ImageItem from 'components/lecturer/ImageItem'
export default {
  components: {
    ImageItem
  },
  props: ['item'],
  computed: util.detailsComputed('item')
}
</script>



// WEBPACK FOOTER //
// SchoolDetail.vue?4e208e03